export const TABS_KEYS = {
  competitorTab: 'competitorTab',
  monitoringTypeTab: 'monitoringType',
  clusterTab: 'clusterTab'
} as const
